import React, { FC, useEffect, useState } from 'react';
import { Button, Card, InputText } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteComponentProps, useParams } from 'react-router-dom';
import ResetPasswordService from '../../services/reset-password';
import notificationsService from '../../services/notifications';
import { ChangePasswordRouteParams } from '../../@types/route-params';

type PropTypes = RouteComponentProps;

const ChangePasswordPage: FC<PropTypes> = ({ history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { id, token, app } = useParams<ChangePasswordRouteParams>();

  const footer = (
    <>
      <Button
        label="Salvar"
        className="login-action"
        type="submit"
        form="reset-password-form"
        disabled={loading}
      />

      <div className="p-text-center">
        { loading && <FontAwesomeIcon icon="spinner" spin /> }
      </div>
    </>
  );

  useEffect(() => { getUser(); }, []);

  const getUser = async () => {
    try {
      setLoading(true);
      const user = await ResetPasswordService.getUser(id, token);

      setEmail(user.email);
    } catch (errorMessage) {
      notificationsService.error({ message: 'Erro ao recuperar senha.' });
      console.error(errorMessage);
      history.push('/login');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    if (password !== confirmationPassword) {
      notificationsService.error({ message: 'As senhas não são iguais.' });
      return;
    }

    event.preventDefault();
    try {
      setLoading(true);
      await ResetPasswordService.changePassword(id, token, password);
      if (app) {
        history.push('/reset_password/confirmation');
      } else {
        history.push('/login');
      }
      notificationsService.success({ message: 'Senha alterada com sucesso.' });
    } catch (errorMessage) {
      console.error(errorMessage);
      notificationsService.error({ message: 'Não foi possível alterar sua senha.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-d-flex p-jc-center login-page">
      <Card className="p-as-center p-p-5" footer={footer} title="Recuperação de senha">
        <form onSubmit={handleResetPassword} id="reset-password-form">
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <InputText
                id="email"
                disabled
                value={email}
                title="email"
              />
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <InputText
                id="password"
                type="password"
                autoFocus
                required
                value={password}
                title="Senha"
                placeholder="Nova senha"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <InputText
                id="confirmationPassword"
                type="password"
                required
                value={confirmationPassword}
                title="Confirmação de senha"
                placeholder="Confirme sua nova senha"
                // eslint-disable-next-line max-len
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmationPassword(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default ChangePasswordPage;
